// export const validateVideoAndCompress = async (
//   file,
//   setCompressionProgress
// ) => {
//   const response = {
//     isValid: true,
//     errorMessage: "",
//   };
//   const video = document.createElement("video");
//   video.src = URL.createObjectURL(file);
//   video.muted = false; // Keep audio enabled

//   const result = await new Promise((resolve, reject) => {
//     video.onloadedmetadata = async () => {
//       // Check duration first
//       if (video.duration > 60) {
//         response.isValid = false;
//         response.errorMessage =
//           "Video duration exceeds the maximum limit of 60 seconds";
//         URL.revokeObjectURL(video.src);
//         resolve(response);
//         return;
//       }

//       // Only compress if resolution is higher than 480p
//       const needsCompression = video.videoHeight > 480;

//       if (needsCompression) {
//         // Start compression immediately for resolution only
//         // setCompressionProgress(0);
//         // setIsSaving(true);
//         // showSnackbar("Optimizing video resolution...", "info");
//         const compressionResponse = await compressVideo(
//           video,
//           480,
//           setCompressionProgress
//         );
//         if (compressionResponse?.isValid) {
//           compressionResponse.outputFile.fileName =
//             file.name + "_compressed.webm";
//           // If compression is successful, return the response
//           URL.revokeObjectURL(video.src);
//           resolve(compressionResponse);
//         }
//       } else {
//         // No compression needed - use original file even if size > 10MB
//         URL.revokeObjectURL(video.src);
//         resolve(response);
//       }
//       video.onerror = () => {
//         response.isValid = false;
//         response.errorMessage = "Error reading video file";
//         URL.revokeObjectURL(video.src);
//         reject(response);
//       };
//     };
//   });

//   return result;
// };

// const compressVideo = async (
//   videoElement,
//   resolution,
//   setCompressionProgress
// ) => {
//   const response = {
//     isValid: true,
//     errorMessage: "",
//     outputFile: null,
//   };

//   if (videoElement.videoHeight <= resolution) {
//     // No compression needed, use original file
//     response.isValid = true;
//     return response;
//   }
//   // setIsSaving(true);
//   // setCompressionProgress(0);

//   // let video = videoElement;
//   // if (!video) {
//   //   video = document.createElement("video");
//   //   video.src = URL.createObjectURL(file);
//   //   video.muted = false; // Keep audio enabled
//   //   await new Promise((resolve) => {
//   //     video.onloadedmetadata = resolve;
//   //   });
//   // }

//   const result = await new Promise((resolve, reject) => {
//     const canvas = document.createElement("canvas");
//     const ctx = canvas.getContext("2d");

//     // Calculate new dimensions - only reduce resolution if height > 480px
//     const aspectRatio = videoElement.videoWidth / videoElement.videoHeight;
//     if (videoElement.videoHeight > 480) {
//       canvas.height = 480;
//       canvas.width = Math.round(480 * aspectRatio);
//     } else {
//       canvas.height = videoElement.videoHeight;
//       canvas.width = videoElement.videoWidth;
//     }

//     videoElement.controls = false;
//     videoElement.addEventListener("pause", () => {
//       videoElement.play(); // auto-resume
//     });

//     // Create audio context to preserve original audio
//     const audioContext = new (window.AudioContext ||
//       window.webkitAudioContext)();
//     const audioSource = audioContext.createMediaElementSource(videoElement);
//     const audioDestination = audioContext.createMediaStreamDestination();
//     audioSource.connect(audioDestination);
//     //audioSource.connect(audioContext.destination);

//     // Combine video stream with original audio
//     const videoStream = canvas.captureStream(30); // Keep original frame rate
//     const audioStream = audioDestination.stream;

//     // Create combined stream with original audio
//     const combinedStream = new MediaStream([
//       ...videoStream.getVideoTracks(),
//       ...audioStream.getAudioTracks(),
//     ]);

//     // Use higher quality settings to preserve audio and minimize size increase
//     const mediaRecorder = new MediaRecorder(combinedStream, {
//       mimeType: "video/webm;codecs=vp9,opus",
//       videoBitsPerSecond: 1000000,
//     });

//     const chunks = [];
//     const videoDuration = videoElement.duration;

//     mediaRecorder.ondataavailable = (event) => {
//       if (event.data.size > 0) {
//         chunks.push(event.data);

//         // Calculate progress based on current time
//         const currentProgress =
//           (videoElement.currentTime / videoDuration) * 100;
//         setCompressionProgress(Math.round(currentProgress));
//       }
//     };

//     mediaRecorder.onstop = () => {
//       setCompressionProgress(100);

//       const compressedBlob = new Blob(chunks, { type: "video/webm" });
//       const compressedFile = new File(
//         [compressedBlob],
//         "compressed_video.webm",
//         { type: "video/webm" }
//       );

//       // Always accept the compressed file regardless of size since we only changed resolution
//       //setFileSizeError(false);
//       //const sizeBefore = (file.size / 1048576).toFixed(2);
//       const sizeAfterInMB = (compressedFile.size / 1048576).toFixed(2);
//       if (sizeAfterInMB > 10) {
//         response.isValid = false;
//         response.errorMessage = `Compressed video size is ${sizeAfterInMB} MB, which exceeds the 10 MB limit.`;
//       } else {
//         response.outputFile = compressedFile;
//       }

//       //setVideoDurationError(false);
//       //setSelectedFile(compressedFile);
//       //setFileName(compressedFile.name);
//       //   const fileUrl = URL.createObjectURL(compressedFile);
//       //   setPreviewUrl(fileUrl);

//       // Clean up audio context
//       audioContext.close();

//       // Reset progress and loading state
//       setTimeout(() => {
//         setCompressionProgress(0);
//         //setIsSaving(false);
//       }, 1000);

//       // Clean up
//       if (videoElement) {
//         URL.revokeObjectURL(videoElement.src);
//       }
//       resolve(response);
//     };

//     mediaRecorder.onerror = (event) => {
//       response.isValid = false;
//       response.errorMessage = "Error during video compression: " + event.error;
//       audioContext.close();
//       reject(response);
//     };

//     videoElement.onended = () => {
//       if (mediaRecorder.state !== "inactive") {
//         mediaRecorder.stop();
//       }
//     };

//     // Start recording
//     mediaRecorder.start(100);
//     videoElement.currentTime = 0;
//     videoElement.loop = false; // Ensure it doesn't loop
//     videoElement.play();

//     const drawFrame = () => {
//       if (videoElement.ended) {
//         mediaRecorder.stop();
//         return;
//       }
//       ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
//       requestAnimationFrame(drawFrame);
//     };

//     drawFrame();
//   });
//   return result;
//   //return response;
// };
export const validateVideoAndCompress = async (
  file,
  setCompressionProgress
) => {
  const response = {
    isValid: true,
    errorMessage: "",
    outputFile: file, // Default to original file
  };

  const video = document.createElement("video");
  video.preload = "metadata";
  video.muted = true; // Start muted to avoid autoplay restrictions
  video.playsInline = true; // Important for mobile Safari
  video.setAttribute("webkit-playsinline", "true"); // Legacy iOS support
  
  const objectUrl = URL.createObjectURL(file);
  video.src = objectUrl;

  try {
    const result = await new Promise((resolve, reject) => {
      video.onloadedmetadata = async () => {
        try {
          // Check duration first
          if (video.duration > 60) {
            response.isValid = false;
            response.errorMessage = "Video duration exceeds the maximum limit of 60 seconds";
            URL.revokeObjectURL(objectUrl);
            resolve(response);
            return;
          }

          // Only compress if resolution is higher than 480p
          const needsCompression = video.videoHeight > 480;

          if (needsCompression) {
            console.log("Starting video compression...");
            const compressionResponse = await compressVideo(
              video,
              480,
              setCompressionProgress
            );
            
            if (compressionResponse?.isValid) {
              compressionResponse.outputFile.fileName = file.name + "_compressed.webm";
              URL.revokeObjectURL(objectUrl);
              resolve(compressionResponse);
            } else {
              URL.revokeObjectURL(objectUrl);
              resolve(compressionResponse);
            }
          } else {
            // No compression needed - use original file
            URL.revokeObjectURL(objectUrl);
            resolve(response);
          }
        } catch (error) {
          console.error("Error in video processing:", error);
          response.isValid = false;
          response.errorMessage = "Error processing video file";
          URL.revokeObjectURL(objectUrl);
          resolve(response);
        }
      };

      video.onerror = (error) => {
        console.error("Video loading error:", error);
        response.isValid = false;
        response.errorMessage = "Error reading video file";
        URL.revokeObjectURL(objectUrl);
        resolve(response);
      };

      // Timeout for video loading (especially important on mobile)
      setTimeout(() => {
        if (video.readyState < 1) {
          console.error("Video loading timeout");
          response.isValid = false;
          response.errorMessage = "Video loading timeout";
          URL.revokeObjectURL(objectUrl);
          resolve(response);
        }
      }, 10000); // 10 second timeout
    });

    return result;
  } catch (error) {
    console.error("Error in validateVideoAndCompress:", error);
    URL.revokeObjectURL(objectUrl);
    response.isValid = false;
    response.errorMessage = "Error processing video file";
    return response;
  }
};

const compressVideo = async (
  videoElement,
  resolution,
  setCompressionProgress
) => {
  const response = {
    isValid: true,
    errorMessage: "",
    outputFile: null,
  };

  if (videoElement.videoHeight <= resolution) {
    // No compression needed, use original file
    response.isValid = true;
    return response;
  }

  try {
    const result = await new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Calculate new dimensions
      const aspectRatio = videoElement.videoWidth / videoElement.videoHeight;
      canvas.height = 480;
      canvas.width = Math.round(480 * aspectRatio);

      // Ensure video is properly configured for mobile
      videoElement.muted = false;
      videoElement.playsInline = true;
      videoElement.setAttribute("webkit-playsinline", "true");
      videoElement.controls = false;

      // Create audio context with better error handling
      let audioContext;
      let audioSource;
      let audioDestination;
      
      try {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        audioSource = audioContext.createMediaElementSource(videoElement);
        audioDestination = audioContext.createMediaStreamDestination();
        audioSource.connect(audioDestination);
      } catch (audioError) {
        console.warn("Audio context creation failed:", audioError);
        // Continue without audio if audio context fails
      }

      // Create video stream
      const videoStream = canvas.captureStream(30);
      
      // Combine streams
      const combinedTracks = [...videoStream.getVideoTracks()];
      if (audioDestination) {
        combinedTracks.push(...audioDestination.stream.getAudioTracks());
      }
      
      const combinedStream = new MediaStream(combinedTracks);

      // Use more conservative settings for mobile compatibility
      const mediaRecorderOptions = {
        mimeType: "video/webm;codecs=vp8,opus", // VP8 is more widely supported than VP9
        videoBitsPerSecond: 800000, // Lower bitrate for mobile
      };

      // Fallback options if the preferred format isn't supported
      let mediaRecorder;
      if (MediaRecorder.isTypeSupported(mediaRecorderOptions.mimeType)) {
        mediaRecorder = new MediaRecorder(combinedStream, mediaRecorderOptions);
      } else {
        // Fallback to default codec
        mediaRecorder = new MediaRecorder(combinedStream);
      }

      const chunks = [];
      const videoDuration = videoElement.duration;
      let startTime = Date.now();

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunks.push(event.data);
          
          // Calculate progress more reliably
          const elapsed = (Date.now() - startTime) / 1000;
          const progress = Math.min((elapsed / videoDuration) * 100, 99);
          setCompressionProgress(Math.round(progress));
        }
      };

      mediaRecorder.onstop = () => {
        setCompressionProgress(100);

        const compressedBlob = new Blob(chunks, { 
          type: mediaRecorder.mimeType || "video/webm" 
        });
        
        const compressedFile = new File(
          [compressedBlob],
          "compressed_video.webm",
          { type: compressedBlob.type }
        );

        const sizeAfterInMB = (compressedFile.size / 1048576).toFixed(2);
        if (sizeAfterInMB > 10) {
          response.isValid = false;
          response.errorMessage = `Compressed video size is ${sizeAfterInMB} MB, which exceeds the 10 MB limit.`;
        } else {
          response.outputFile = compressedFile;
        }

        // Clean up
        if (audioContext) {
          audioContext.close().catch(console.warn);
        }

        setTimeout(() => {
          setCompressionProgress(0);
        }, 1000);

        resolve(response);
      };

      mediaRecorder.onerror = (event) => {
        console.error("MediaRecorder error:", event.error);
        response.isValid = false;
        response.errorMessage = "Error during video compression: " + event.error;
        
        if (audioContext) {
          audioContext.close().catch(console.warn);
        }
        
        resolve(response);
      };

      // Handle video end
      videoElement.onended = () => {
        if (mediaRecorder.state === "recording") {
          mediaRecorder.stop();
        }
      };

      // Start recording
      mediaRecorder.start(100);
      videoElement.currentTime = 0;
      videoElement.loop = false;
      
      // Start playback with better mobile handling
      const playPromise = videoElement.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.error("Video play failed:", error);
          response.isValid = false;
          response.errorMessage = "Failed to start video playback for compression";
          resolve(response);
        });
      }

      const drawFrame = () => {
        if (videoElement.ended || mediaRecorder.state !== "recording") {
          return;
        }
        
        if (videoElement.readyState >= 2) { // HAVE_CURRENT_DATA
          ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        }
        
        requestAnimationFrame(drawFrame);
      };

      drawFrame();
    });

    return result;
  } catch (error) {
    console.error("Error in compressVideo:", error);
    response.isValid = false;
    response.errorMessage = "Error during video compression";
    return response;
  }
};